import React from 'react';

export default function Block2Why() {
  return (
    <section className="py-10 md:py-20 px-4 md:px-16 bg-paper border-b border-line">
      <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row items-center justify-between gap-16 w-full">
        <div className="w-full md:w-[50%] flex flex-col items-start">
          <div className="text-[11px] font-semibold text-ink-soft/70 mb-4 uppercase tracking-widest">
            Trayectoria de riesgo y pérdida de continuidad
          </div>
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink leading-[1.2] tracking-tight mb-6">
            La hospitalización no comienza en el hospital.
          </h2>
          <p className="text-[16px] md:text-[18px] text-ink-soft leading-[1.6]">
            Toda complicación grave es el resultado de un evento previo omitido o de una trayectoria interrumpida. Identificar el riesgo no es suficiente si la persona pierde continuidad en la red asistencial.
          </p>
        </div>
        <div className="w-full md:w-[40%] flex justify-center md:justify-start">
          <div className="flex flex-col relative py-4">
            <div className="absolute left-[7px] top-6 bottom-6 w-[2px] bg-line" aria-hidden="true" />
            <div className="flex items-start gap-6 mb-8 relative z-10">
              <div className="w-[16px] h-[16px] rounded-full bg-paper border-2 border-slate-300 mt-1 shrink-0" />
              <div>
                <div className="text-[16px] font-medium text-ink-soft">Riesgo / Enfermedad leve</div>
                <div className="text-[13px] text-ink-soft/70 mt-1">Antes del diagnóstico o en control regular</div>
              </div>
            </div>
            <div className="flex items-start gap-6 mb-8 relative z-10">
              <div className="w-[16px] h-[16px] rounded-full bg-rupture border-2 border-paper mt-1 shrink-0 shadow-[0_0_0_2px_rgba(201,132,42,0.3)]" />
              <div>
                <div className="text-[18px] font-bold text-ink">Pérdida de continuidad</div>
                <div className="text-[13px] text-ink-soft/70 mt-1">Brecha operativa / cita perdida / examen pendiente</div>
              </div>
            </div>
            <div className="flex items-start gap-6 mb-8 relative z-10">
              <div className="w-[16px] h-[16px] rounded-full bg-paper border-2 border-slate-400 mt-1 shrink-0" />
              <div>
                <div className="text-[16px] font-medium text-ink-soft">Complicación temprana</div>
              </div>
            </div>
            <div className="flex items-start gap-6 relative z-10">
              <div className="w-[16px] h-[16px] rounded-full bg-ink mt-1.5 shrink-0" />
              <div>
                <div className="text-[20px] md:text-[24px] font-bold text-ink tracking-tight">Hospitalización</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
